import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import type {
    ProSkillAssureTrackLevelModel
} from "~~/package/mapper/proSkillAssure/model/ProSkillAssureTrackLevelModel";
import { ProSkillManagerType } from "~~/package/mapper/proSkillManager/model/ProSkillManagerType";
import { ModifyScopeType } from "~~/package/mapper/proSkillAssure/model/ModifyScopeType";

export class ProSkillAssureAssessmentDetailModel extends Model {
    constructor(
        public assessmentTitle: string = "",
        public type: ProSkillManagerType = ProSkillManagerType.ALL,
        public startedAt: string = "",
        public endedAt: string = "",
        public description: string = "",
        public duration: number = 0,
        public eyeTrackingFlag: boolean = false,
        public tabProctoringFlag: boolean = false,
        public shortcutFlag: boolean = false,
        public multiMonitorFlag: boolean = false,
        public copyPasteFlag: boolean = false,
        public screenRecordingFlag: boolean = false,
        public useExternalMonitoringFlag: boolean = false,
        public setList: ProSkillAssureTrackLevelModel[] = [],
        // public assessmentSetInfoVOList: ProSkillAssureAssessmentSetInfoModel[] = [],
        public modifyScope: ModifyScopeType = ModifyScopeType.ALL,
        public creditPerCandidate: number = 0,
        public timeZoneId: string = "",
        public reportLangs: string[] = ["EN"]
    ) {
        super();
    }

    public static create(model: Partial<ProSkillAssureAssessmentDetailModel>): ProSkillAssureAssessmentDetailModel {
        return createModel<ProSkillAssureAssessmentDetailModel>(ProSkillAssureAssessmentDetailModel, {
            ...model
        });
    }
}
